module.exports = __webpack_public_path__ + "static/media/wheelChair.53e0c784.svg";